// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"5cc45587","270":"5cc45587","814":"5c513289"}[chunkId] + ".chunk.css";
};